import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Text } from 'ilenia';
import { Common } from './../../Assets/styles/common';

interface ButtonNotificationProps extends React.HTMLProps<HTMLDivElement> {
    showMessage?: boolean;
    textId?: string;
}

export class ButtonNotification extends React.Component<ButtonNotificationProps> {
    constructor(props: ButtonNotificationProps) {
        super(props);
    }

    public render() {
        const {showMessage, textId} = this.props;
        return (
            <div>
                {showMessage && textId ? <div className={css(styles.successElement)}><Text id={textId} /></div> : ''}
            </div>
        );
    }
}

const styles = StyleSheet.create({
    successElement: {
        margin: '10px',
        color: Common.Color.greenColor,
        position: 'absolute'
    },
});
